<template>
  <Modal
    class="dea-modal--email-confirmation"
    extra-class="dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      Conferma indirizzo email
    </template>
    <template #content>
      <div class="dea-heading--regular-s">
        Per confermare l'indirizzo email {{ emailTarget }} in forma definitiva, clicca sul link che ti abbiamo inviato
        all'email da te fornita. Attenzione, il link ha una durata di 24 ore.
      </div>
      <div class="dea-modal__buttons-container">
        <Buttons class="dea-button--large" @click="$emit('confirm-email', emailTarget)">Okay, procedi</Buttons>
        <Buttons class="dea-button--large dea-button--outline" @click="$emit('modal-close')">Annulla</Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";

export default {
  name: "EmailConfirmationModal",
  components: { Buttons, Modal },
  props: {
    emailTarget: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$mail-input-width: 330px;

.dea-modal--email-confirmation {
  .dea-modal__buttons-container {
    display: flex;
  }

  .dea-button {
    margin-right: $space-base;
    margin-top: $space-small !important; //sass-lint:disable-line no-important
  }
}
</style>
